import React from 'react';
import SuccessModal from '../../../components/modals/SuccessModal';
import DeviceConnectionModal from '../../../components/modals/DeviceConnectionModal';
import ConfirmDetailsModal from '../../../components/modals/ConfirmDetailsModal';
import ExitSetupModal from '../../../components/modals/ExitSetupModal';
import { useDeviceConfigFlowWeb } from './useDeviceConfigFlowWeb';
import Step1TurnOn from './Step1TurnOn';
import Step2WifiServer from './Step2WifiServer';
import Step3ConnectDeviceWifi from './Step3ConnectDeviceWifi';
import Step4SendWifi from './Step4SendWifi';
import Step5ConnectInternet from './Step5ConnectInternet';
import Step6Done from './Step6Done';
import Step6Failed from './Step6Failed';
import '../../../styles/pages/device-config-flow-mobile.css';
import './webFlow.css';

interface DeviceConfigFlowWebProps {
  setShowConfigFlow: React.Dispatch<React.SetStateAction<boolean>>;
  SerialNumber: string;
  deviceId?: string;
}

const DeviceConfigFlowWeb: React.FC<DeviceConfigFlowWebProps> = ({
  setShowConfigFlow,
  SerialNumber,
  deviceId,
}) => {
  const {
    ctx,
    popup,
    confirmPopup,
    exitModalOpen,
    closePopup,
    closeConfirmPopup,
    closeExitModal,
    exitSetup,
  } = useDeviceConfigFlowWeb({ setShowConfigFlow, SerialNumber, deviceId });

  const handlePopupAction = () => {
    const cb = popup.onAction;
    closePopup();
    cb?.();
  };

  return (
    <>
      {ctx.step === 'on' && <Step1TurnOn ctx={ctx} />}
      {ctx.step === 'wificonf' && <Step2WifiServer ctx={ctx} />}
      {ctx.step === 'deviceWifi' && <Step3ConnectDeviceWifi ctx={ctx} />}
      {ctx.step === 'sendWifi' && <Step4SendWifi ctx={ctx} />}
      {ctx.step === 'internet' && <Step5ConnectInternet ctx={ctx} />}
      {ctx.step === 'done' && <Step6Done ctx={ctx} />}
      {ctx.step === 'failed' && <Step6Failed ctx={ctx} />}

      {popup.variant === 'device' ? (
        <DeviceConnectionModal
          isOpen={popup.isOpen}
          onClose={closePopup}
          title={popup.title}
          subtitle={popup.subtitle}
          status={popup.status}
          actionText={popup.actionText}
          onAction={popup.onAction ? handlePopupAction : undefined}
        />
      ) : (
        <SuccessModal
          isOpen={popup.isOpen}
          onClose={closePopup}
          title={popup.title}
          subtitle={popup.subtitle}
          status={popup.status}
          showAlertIcon={popup.showAlertIcon}
          actionText={popup.actionText}
          onAction={popup.onAction ? handlePopupAction : undefined}
        />
      )}

      <ExitSetupModal
        isOpen={exitModalOpen}
        onContinue={closeExitModal}
        onDiscard={exitSetup}
      />

      <ConfirmDetailsModal
        isOpen={confirmPopup.isOpen}
        onClose={closeConfirmPopup}
        onEdit={closeConfirmPopup}
        onConfirm={ctx.confirmWifiDetails}
        title="Confirmation Details"
        details={[
          { label: 'Wifi Name', value: ctx.wifiname || '—' },
          { label: 'Wifi Password', value: ctx.wifipassword || '—' },
        ]}
        description="Please verify that the entered credentials are correct and connected to the 2.4 GHz network. If invalid, the Wi-Fi LED will turn red and data transmission to the application will stop after 1–2 minutes. Please reconfigure the connection if needed."
      />
    </>
  );
};

export default DeviceConfigFlowWeb;
